import { combineReducers } from '@ngrx/store';
import { SignupState, signupReducer } from './signup/signup_state';
import { InstallState, installReducer } from './install/install_state';

export interface AppState {
  install: InstallState;
  signup: SignupState;
}

export interface IAppState {
  app: AppState;
}

export const appReducer = combineReducers({
  install: installReducer,
  signup: signupReducer,
});
